import { FC } from 'react'
import { Box } from '@mui/material'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import i18n from '../../../i18n/i18next'

type TDistanceAwayTagProps = {
    distanceAway: string
}

export const DistanceAwayTag: FC<TDistanceAwayTagProps> = ({
    distanceAway,
}) => {
    return (
        <Box
            sx={{
                backgroundColor: ColoursObj.backgrounds.primary,
                borderRadius: '24px',
                width: 'max-content',
                height: '24px',
                padding: '0 8px',
            }}
        >
            <Typography variant="bodyBold">
                {distanceAway} km {i18n.t('booking.away')}
            </Typography>
        </Box>
    )
}
